/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

//const Formatter = { format: (a) => { return a; } }; //require('gemini/lib/@waca/core-client/js/core-client/i18n/Formatter');
export const Formatter = require('gemini/lib/@waca/core-client/js/core-client/i18n/Formatter');



// WEBPACK FOOTER //
// ./src/js/features/compare/FormatterWrapper.js